import { useTranslation } from '@gimlite/common';
import { observer } from 'mobx-react-lite';
import { CredentialType } from '../../common/mapper/credential.mapper';
import {
  CredentialCard,
  CredentialCardType,
  CredentialMini,
} from '../../components/credential/credential.component';
import { useStoreUIV1 } from '@gimlite/ui-v1';

export class RFIDCredentialStatic {
  static info: CredentialType.Static<RFIDCredentialCardType.Data> = {
    name: 'RFID',
    icon: 'customDish',
    backgroundColor: { light: '#333333', dark: '#e8e8e8' },
    color: { light: '#e8e8e8', dark: '#333333' },
    category: 'RFID',
    primaryValue: 'uid',
  };
}

export declare namespace RFIDCredentialMiniType {
  type Props = {
    data?: {
      value?: string | null;
    };
  };
}

export const RFIDCredentialMini = observer(
  ({ data: { value } = {} }: RFIDCredentialMiniType.Props) => {
    const { ThemeStore } = useStoreUIV1();

    return (
      <CredentialMini
        data={{ text: value }}
        config={{
          icon: RFIDCredentialStatic.info.icon,
          backgroundColor:
            RFIDCredentialStatic.info.backgroundColor[ThemeStore.theme],
          color: RFIDCredentialStatic.info.color[ThemeStore.theme],
        }}
      />
    );
  },
);

export declare namespace RFIDCredentialCardType {
  type Props = {
    handleEvent?: {
      event?: CredentialCardType.HandleEvent.Event['function'];
    };
    data: RFIDCredentialCardType.Data;
    config?: {
      isActive?: boolean;
    };
  };

  type Data = {
    _id: string;
    uid: string;
    visibleId: string;
  };
}

export const RFIDCredentialCard = observer(
  ({
    handleEvent: { event } = {},
    data: { _id, uid, visibleId },
    config: { isActive = true } = {},
  }: RFIDCredentialCardType.Props) => {
    const { t, lang } = useTranslation();
    const { ThemeStore } = useStoreUIV1();

    return (
      <CredentialCard.Context.Consumer>
        {({ place, edit }) => {
          return (
            <CredentialCard
              handleEvent={{ event, edit }}
              data={{
                name: RFIDCredentialStatic.info.name,
                info: [
                  { key: 'uid', label: t('uid'), value: uid, _id },
                  {
                    key: 'visibleId',
                    label: t('visibleId'),
                    value: visibleId,
                    _id,
                  },
                ],
                category: RFIDCredentialStatic.info.category,
                primaryValue: RFIDCredentialStatic.info.primaryValue,
              }}
              config={{
                icon: RFIDCredentialStatic.info.icon,
                backgroundColor:
                  RFIDCredentialStatic.info.backgroundColor[ThemeStore.theme],
                color: RFIDCredentialStatic.info.color[ThemeStore.theme],
                disabled: !isActive,
                action:
                  place === 'contractDisabled'
                    ? []
                    : !isActive
                      ? [{ label: t('import'), value: 'import' }]
                      : place === 'contract' || place === 'contractWithMotorist'
                        ? [
                            { label: t('edit'), value: 'edit' },
                            { label: t('delete'), value: 'delete' },
                          ]
                        : place === 'wizardContractExist'
                          ? [{ label: t('delete'), value: 'delete' }]
                          : place === 'wizardNewContract'
                            ? [{ label: t('delete'), value: 'delete' }]
                            : [],
              }}
            />
          );
        }}
      </CredentialCard.Context.Consumer>
    );
  },
);
